// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { server } from "./AppConfig"

var firebaseConfig

if (server === "production") {
    firebaseConfig = {
        apiKey: "AIzaSyB4kYvRZc5qJx5PHF8yzCP9FU0g4Gywe84",
        authDomain: "accrue-d0a3c.firebaseapp.com",
        databaseURL: "https://accrue-d0a3c.firebaseio.com",
        projectId: "accrue-d0a3c",
        storageBucket: "accrue-d0a3c.appspot.com",
        messagingSenderId: "507319909652",
        appId: "1:507319909652:web:451f14efa61464b6bd9601",
        measurementId: "G-F0BVDGS6J4"
    };

} else {
    firebaseConfig = {
        apiKey: "AIzaSyDv-7Y4qdjQAUV-JqfE5Zmi0inLqhrx05E",
        authDomain: "accrue-uat.firebaseapp.com",
        databaseURL: "https://accrue-uat.firebaseio.com",
        projectId: "accrue-uat",
        storageBucket: "accrue-uat.appspot.com",
        messagingSenderId: "210300360972",
        appId: "1:210300360972:web:09ff669d2f6a5807c11129",
        measurementId: "G-HRS1W30K8T"
    };
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app

